export default "__VITE_ASSET__BuFuiTbF__"